import { useState } from "react";
import { Link } from "gatsby";
import React from "react";
import Avatar from "react-avatar";

const BlogSidebar = ({ author, recentData, heading, iframes = [] }) => {
  function getDate(updatedAt) {
    const date = new Date(updatedAt);
    const formattedDate = date.toLocaleString("en-US", {
      weekday: "short",
      month: "short",
      year: "numeric",
    });

    return formattedDate; // Output: "Fri, Mar 2012"
  }

  function truncateText(str, length) {
    return str.length > length ? str.substring(0, length) + "..." : str;
  }

  function extractContentFromHTML(htmlString) {
    if (typeof htmlString === "string") {
      const plainText = htmlString
        ?.replace(/<[^>]+>/g, "")
        .replaceAll("&nbsp;", " ")
        .replaceAll("&rsquo;", "' ")
        .replaceAll("&ndash;", "-")
        .replaceAll("&amp;", "&");

      if (plainText) {
        return truncateText(plainText, 80);
      } else {
        return "";
      }
    }
    return "";
  }

  return (
    <div className="blogsidebar">
      {/* Author */}
      {author && (
        <section className="">
          <div className="max-w-4xl mx-auto">
            <div className="md:flex md:space-x-4">
              {author.image ? (
                <div className="author_roundedw-[100px] h-[100px]">
                  <img
                    className="object-cover w-[100px] h-[100px]"
                    src={author.image}
                    alt={author.name}
                  />
                </div>
              ) : (
                <div className="author_roundedw-[100px] h-[100px]">
                  <Avatar
                    name={author.title}
                    size="100"
                    className="object-cover w-[100px] h-[100px]"
                  />
                </div>
              )}
              <div className="">
                <h4 className="text-lg font-semibold text-white tracking-wide">
                  {author.title}
                </h4>
                {author.body && (
                  <p className="text-base text-gray-200">
                    {extractContentFromHTML(author.body)}
                  </p>
                )}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Popular posts */}

      <div className="popularpost__container">
        <h4>{heading}</h4>
        {recentData && (
          <div className="popularpost__list">
            {recentData.map((item, index) => (
              <Link
                to={`/${item.slug}`}
                key={index}
                className="popularpost__card no-underline"
              >
                {!!item.images.length ? (
                  <img
                    src={item.images[0]}
                    alt={item.title}
                    className="thumb__img"
                  />
                ) : (
                  <div className="thumb__img" />
                )}
                <div className="content">
                  <h6>{getDate(item.created_at)}</h6>
                  <h5>{item.title}</h5>
                </div>
              </Link>
            ))}
          </div>
        )}
        <div
          className={`${
            recentData ? "iframes__list" : "iframes__list_without_blogs"
          } space-y-3 sm:space-y-0 sm:space-x-5 lg:space-x-0 lg:space-y-5 flex flex-col sm:flex-row lg:flex-col`}
        >
          {iframes.map((id) => (
            <iframe
              key={id}
              src={`https://ads.catcomnet.com/ad-spaces/${id}/embed`}
              allow="geolocation: *"
              width="200"
              height="400"
              className="rounded-xl"
            ></iframe>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogSidebar;
